import { paths } from '@shared/enums/paths';

export const flagBackLinkPathByUserIdEditPage = (id: string): string => `${paths.users}/${id}/${paths.flags}`;
